module.exports = __webpack_public_path__ + "img/down.a17a9d7b.png";